import { Component } from "react";
import { connect } from "react-redux";
import ApplicationTable from "./ApplicationTable";
import SearchApplicationTable from "./SearchApplicationTable";
import ApplicationTablePagination from "./ApplicationTablePagination";

class Home extends Component {
  render() {
    return (
      <div>
        <h5 style={{ display: "flex", alignItems: "center" }}>
          الصفحة الرئيسية
          <span
            style={{
              width: 0,
              height: 0,
              borderTop: "6px solid transparent",
              borderBottom: "6px solid transparent",
              borderRight: "10px solid black",
              marginRight: "8px",
            }}
          ></span>{" "}
        </h5>
        <div className="d-flex  justify-content-between">
          <SearchApplicationTable />
        </div>
        <hr />
        <ApplicationTable />
      </div>
    );
  }
}

const mapDispatchToProps = {};
const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(Home);
